import { API } from 'aws-amplify';
import appSyncClient from '../appsync/client';
import GetUserInfoQuery from '../appsync/queries/GetUser';
import { forSocialData, forDeviceData } from '../utils/scoringPayload';

const postData = async (payload, createRequest) => {
  const { data } = await appSyncClient.query({
    query: GetUserInfoQuery,
    fetchPolicy: 'network-only',
  });

  const { user } = data;
  const body = await createRequest(payload, user?.agreement);
  const postResponseData = await API.post('ScoringData', '/', { body });

  if (postResponseData.statusCode !== 200) {
    throw new Error(JSON.stringify(postResponseData));
  }
  return postResponseData;
};

export const postSkipBanking = async (clientId, requestId, skippedBanking) => {
  const response = await API.post('SkipBanking', '/', { body: { clientId, requestId, skippedBanking } });
  if (response.status !== 200) {
    throw new Error(JSON.stringify(response));
  }
  return response;
};

export const postSocialData = (payload) => postData(payload, forSocialData);

export const postDeviceData = (payload) => postData(payload, forDeviceData);
